"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,2.00000001 C17.5228474,2.00000001 22,6.4771525 22,12 C22,17.5228474 17.5228474,22 12,22 C6.4771525,22 2.00000001,17.5228474 2.00000001,12 C2.00000001,6.4771525 6.4771525,2.00000001 12,2.00000001 Z M12,3.99999999 C7.58172201,3.99999999 3.99999999,7.58172201 3.99999999,12 C3.99999999,16.418278 7.58172201,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.58172201 16.418278,3.99999999 12,3.99999999 Z M12,5.00000001 C12.5522847,5.00000001 13,5.44771526 13,6.00000001 L12.9988571,11.564 L16.4331669,14.6049863 C16.8222873,14.9493998 16.8585295,15.5440465 16.514116,15.9331669 C16.5014615,15.9474641 16.4883746,15.9613728 16.4748737,15.9748737 C16.0775779,16.3721696 15.4396827,16.3915906 15.0189533,16.0191999 L11.3346,12.7581506 C11.2048932,12.6433461 11.1143951,12.5007379 11.0641345,12.347206 L11.0509807,12.3160773 C11.0179086,12.2167311 11,12.1104569 11,12 L11,6.00000001 C11,5.44771526 11.4477153,5.00000001 12,5.00000001 Z"
  });
}.bind(void 0));

exports.default = _default;